export default __webpack_public_path__ + "locales/sq-AL/WebPlugins.json?hash=e1ed489d4d3bf5f75c962675135043a5";